import React from 'react';
import { Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
const OPERATION_STATES = {
  1: 'Shipment',
  2: 'Factory Default',
  8: 'Unpaired',
  9: 'Paired',
  10: 'Sold',
  11: 'Active Theft Recovery',
  12: 'Disabled'
};
export default function OperationState(props) {
  const {
    value,
    isDetail,
    defaultValue = '---'
  } = props;
  const stringValue = value?.toString?.();
  if (!stringValue) {
    return defaultValue;
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: isDetail ? 'detailValue' : 'columnValue',
    children: OPERATION_STATES[stringValue] || stringValue
  });
}